import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentForAnonymous from '../../../../../CommentForAnonymous';

interface Props {}

const AnonymousView: React.FC<Props> = () => {
  const isMobile = useContext(MobileContext);
  return (
    <CommentBoxLayout
      avatar={!isMobile && <CommentBoxAvatar withLink={false} />}
      content={<CommentForAnonymous />}
    />
  );
};
AnonymousView.displayName = 'AnonymousView';

export default AnonymousView;
